import { services, hooks } from "../../../studentportal-sdk";
import { useEffect } from "react";

export const LiveSessionHook = (props) => {
  // liveSession service instance
  const _liveSessionService = services.LiveClass(props);

  const {
    action: {
      getLiveClass
    },
  } = _liveSessionService;

  useEffect(() => {
    getLiveClass()
  }, [])

 

  return {
    liveSessionService: {
      ..._liveSessionService,
    },
    ...props,
  };
};

export const liveSession = (props) =>
  LiveSessionHook(hooks.UtilityAndConfig(props));
